import React from 'react'
import Navbar from '../../components/Navbar'
import Footer from '../../components/Footer'
import { Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { SiteCard } from './ProductShowcase'

function Wasteheatrecovery() {
  const navigate = useNavigate()

  return (
    <>
      <Navbar />

      <main className='page-shell'>
        <div className='page-title-block'>
          <Typography className='page-title'>Genset Waste Heat Recovery to Utilization</Typography>
          <Typography className='page-subtitle'>
            Hot water for pools and bathrooms, recovered from power generators and chillers.
          </Typography>
        </div>

        <div className='pp-site-grid'>
          <SiteCard
            image='/machines-images/Waste Heat Recovery/reethi_beach.jpeg'
            title='Reethi Beach Resort, Maldives'
            caption='Waste heat recovery for an island resort'
            onOpen={() => navigate('/product/wasteheatrecovery/reethi-beach-resort')}
          />
          <SiteCard
            image='/machines-images/Heat Pump/Property/wynberg.png'
            title='Wynberg Allen School, Mussoorie'
            caption='Hot water from genset waste heat for a hill school'
            onOpen={() => navigate('/product/wasteheatrecovery/wynberg')}
          />
        </div>
      </main>

      <Footer />
    </>
  )
}

export default Wasteheatrecovery
